import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref } from "vue";
import _imports_0 from './img/left.png';
import _imports_1 from './img/right.png';
import _imports_2 from './img/solution_icon1.png';
import _imports_3 from './img/solution_icon2.png';
import _imports_4 from './img/solution_icon3.png';
import _imports_5 from './img/solution_icon4.png';
import _imports_6 from './img/solution_icon5.png';
import _imports_7 from './img/vs_icon.png';
const _hoisted_1 = {
  class: "home-head"
};
const _hoisted_2 = {
  class: "banner-content"
};
const _hoisted_3 = {
  class: "banner-title1"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  style: {
    "color": "#ff282d"
  }
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  style: {
    "color": "#ff282d"
  }
};
const _hoisted_8 = {
  class: "banner-descripe"
};
const _hoisted_9 = {
  class: "banner-tips"
};
const _hoisted_10 = {
  class: "nav-card-box"
};
const _hoisted_11 = {
  class: "nav-card nav-card-img1"
};
const _hoisted_12 = {
  class: "nav-card-content"
};
const _hoisted_13 = {
  class: "nav-card nav-card-img2"
};
const _hoisted_14 = {
  class: "nav-card-content"
};
const _hoisted_15 = {
  class: "nav-card-time"
};
const _hoisted_16 = {
  class: "nav-card nav-card-img3"
};
const _hoisted_17 = {
  class: "nav-card-content"
};
const _hoisted_18 = {
  class: "nav-card-time"
};
const _hoisted_19 = {
  class: "nav-card nav-card-img4"
};
const _hoisted_20 = {
  class: "nav-card-content"
};
const _hoisted_21 = {
  class: "nav-card-time"
};
const _hoisted_22 = {
  class: "partner-box"
};
const _hoisted_23 = {
  class: "partner-title"
};
const _hoisted_24 = {
  class: "sub-title"
};
const _hoisted_25 = {
  class: "swiper-box swiper-con3"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  class: "hot-service"
};
const _hoisted_28 = {
  class: "big-title"
};
const _hoisted_29 = {
  class: "use-content"
};
const _hoisted_30 = {
  class: "left-box"
};
const _hoisted_31 = ["onClick"];
const _hoisted_32 = {
  class: "title"
};
const _hoisted_33 = {
  class: "note"
};
const _hoisted_34 = {
  class: "price-btn"
};
const _hoisted_35 = {
  class: "price"
};
const _hoisted_36 = {
  class: "btn"
};
const _hoisted_37 = {
  class: "tans-solution"
};
const _hoisted_38 = {
  class: "big-title"
};
const _hoisted_39 = {
  class: "descript"
};
const _hoisted_40 = {
  class: "contrast"
};
const _hoisted_41 = {
  class: "ue-content"
};
const _hoisted_42 = {
  class: "content-item"
};
const _hoisted_43 = {
  class: "title"
};
const _hoisted_44 = {
  class: "notes"
};
const _hoisted_45 = {
  class: "content-item"
};
const _hoisted_46 = {
  class: "title"
};
const _hoisted_47 = {
  class: "notes"
};
const _hoisted_48 = {
  class: "content-item"
};
const _hoisted_49 = {
  class: "title"
};
const _hoisted_50 = {
  class: "notes"
};
const _hoisted_51 = {
  class: "content-item"
};
const _hoisted_52 = {
  class: "title"
};
const _hoisted_53 = {
  class: "notes"
};
const _hoisted_54 = {
  class: "content-item"
};
const _hoisted_55 = {
  class: "title"
};
const _hoisted_56 = {
  class: "notes",
  style: {
    "border": "0"
  }
};
const _hoisted_57 = {
  class: "tradition-content"
};
const _hoisted_58 = {
  class: "title"
};
const _hoisted_59 = {
  class: "text1"
};
const _hoisted_60 = {
  class: "text2"
};
const _hoisted_61 = {
  class: "text3"
};
const _hoisted_62 = {
  class: "text4"
};
const _hoisted_63 = {
  class: "text5"
};
import { HotService } from '@/utils/const';
import qs from 'qs';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { reactive, ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'partTop',
  setup(__props) {
    const advisoryServiceRef = ref(null);
    const goAdvisory = () => {
      advisoryServiceRef['value'].show();
    };
    const rangeList = reactive([{
      id: '2001',
      title: 'home.text59',
      desc: 'home.text60',
      img: require('./img/range1.png')
    }, {
      id: '2060',
      title: 'home.text61',
      desc: 'home.text62',
      img: require('./img/range2.png')
    }, {
      id: '2000',
      title: 'home.text63',
      desc: 'home.text64',
      img: require('./img/range3.png')
    }, {
      id: '2063',
      title: 'home.text67',
      desc: 'home.text68',
      img: require('./img/range5.png')
    }, {
      id: '2044',
      title: 'home.text69',
      desc: 'home.text70',
      img: require('./img/range6.png')
    }, {
      id: '2056',
      title: 'home.text71',
      desc: 'home.text72',
      img: require('./img/range7.png')
    }, {
      id: '2068',
      title: 'home.text73',
      desc: 'home.text74',
      img: require('./img/range8.png')
    }, {
      id: '2067',
      title: 'home.text75',
      desc: 'home.text76',
      img: require('./img/range9.png')
    }, {
      id: '2054',
      title: 'home.text77',
      desc: 'home.text78',
      img: require('./img/range10.png')
    }, {
      id: '2055',
      title: 'home.text79',
      desc: 'home.text80',
      img: require('./img/range11.png')
    }, {
      id: '2057',
      title: 'home.text81',
      desc: 'home.text82',
      img: require('./img/range12.png')
    }, {
      id: '2058',
      title: 'home.text83',
      desc: 'home.text84',
      img: require('./img/range13.png')
    }, {
      id: '2059',
      title: 'home.text85',
      desc: 'home.text86',
      img: require('./img/range14.png')
    }, {
      id: '2061',
      title: 'home.text87',
      desc: 'home.text88',
      img: require('./img/range15.png')
    }, {
      id: '2062',
      title: 'home.text89',
      desc: 'home.text90',
      img: require('./img/range16.png')
    }, {
      id: '2065',
      title: 'home.text91',
      desc: 'home.text92',
      img: require('./img/range17.png')
    }, {
      id: '2123',
      title: 'home.text93',
      desc: 'home.text94',
      img: require('./img/range18.png')
    }, {
      id: '2037',
      title: 'home.text95',
      desc: 'home.text96',
      img: require('./img/range19.png')
    }, {
      id: '2066',
      title: 'home.text97',
      desc: 'home.text98',
      img: require('./img/range20.png')
    }, {
      id: '2064',
      title: 'home.text65',
      desc: 'home.text66',
      img: require('./img/range4.png')
    }]);
    const partnerImgs = ref([
    // require('./img/partners1.png'),
    require('./img/partners2.png'), require('./img/partners3.png'), require('./img/partners6.png'), require('./img/partners8.png'), require('./img/partners7.png'), require('./img/partners12.png'), require('./img/partners5.png'), require('./img/partners9.png'), require('./img/partners4.png'), require('./img/partners13.png'), require('./img/partners10.png'), require('./img/partners11.png')]);
    const bannerImgs = ref([{
      className: 'bg1',
      redTitle: 'AI翻译+两轮资深审校，',
      title1: '品质媲美人工翻译',
      descripe: '',
      tips: ['home.hot_service8', 'home.hot_service11', 'home.hot_service12', 'home.hot_service13']
    }, {
      className: 'bg2',
      title1: '交付速度提升2倍，',
      redTitle: '费用降低一半',
      descripe: 'home.hot_service16',
      tips: ['home.hot_service17', 'home.hot_service18', 'home.hot_service19', 'home.hot_service20']
    }, {
      className: 'bg4',
      redTitle: '专业图纸翻译，',
      title1: '助您的项目全球畅行。',
      descripe: 'home.hot_service27',
      isContact: true
    }
    // {
    //   className: 'bg3',
    //   redTitle: 'home.hot_service21',
    //   title: 'home.hot_service22',
    //   descripe: 'home.hot_service23',
    //   tips: ['home.hot_service24', 'home.hot_service25', 'home.hot_service26']
    // }
    ]);
    const modules = [Navigation];
    // 去下单
    const toOrder = (params, item) => {
      const link = (item === null || item === void 0 ? void 0 : item.link) || '/client/order';
      if (params) {
        params = qs.stringify(params);
        window.location.href = `${link}?${params}`;
      } else {
        window.location.href = link;
      }
    };
    return (_ctx, _cache) => {
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_carousel = _resolveComponent("el-carousel");
      const _component_AdvisoryService = _resolveComponent("AdvisoryService");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_carousel, {
        height: "360px",
        "indicator-position": "none",
        interval: 5000
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bannerImgs.value, (item, index) => {
          return _openBlock(), _createBlock(_component_el_carousel_item, {
            key: item
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(["home-banner", item.className])
            }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [!index || index == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t(item.redTitle)), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t(item.title1)), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(_ctx.$t(item.title1)), 1), _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t(item.redTitle)), 1)])), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t(item.descripe)), 1)]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tips, tip => {
              return _openBlock(), _createElementBlock("div", {
                key: tip,
                class: "banner-item"
              }, _toDisplayString(_ctx.$t(tip)), 1);
            }), 128))]), item.isContact ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "consult-btn",
              onClick: goAdvisory
            }, _toDisplayString(_ctx.$t('aboutUs.text25')), 1)) : _createCommentVNode("", true)])], 2)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('home.text179')), 1)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('home.text9')), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('home.text10')), 1)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('home.text11')), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('home.text12')), 1)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('home.text13')), 1), _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('home.text14')), 1)])])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_cache[1] || (_cache[1] = _createElementVNode("h3", {
        class: "title"
      }, "我们与以下客户签订了合作协议", -1)), _createElementVNode("p", _hoisted_24, [_createTextVNode(_toDisplayString(_ctx.$t('home.text100')) + " ", 1), _cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "number"
      }, "1700+", -1)), _createTextVNode(" " + _toDisplayString(_ctx.$t('home.text101')), 1)])]), _createElementVNode("div", _hoisted_25, [_createVNode(_unref(Swiper), {
        class: "swiper-lists",
        loop: true,
        "loop-additional-slides": 5,
        "space-between": 0,
        "slide-to-clicked-slide": true,
        width: 180,
        modules: modules,
        keyboard: true,
        mousewheel: true,
        navigation: {
          nextEl: '.swiper-con3 .swiper-button-next',
          prevEl: '.swiper-con3 .swiper-button-prev'
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partnerImgs.value, (item, index) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("img", {
              src: item
            }, null, 8, _hoisted_26)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }), _cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_0,
        class: "swiper-button-prev"
      }, null, -1)), _cache[3] || (_cache[3] = _createElementVNode("img", {
        src: _imports_1,
        class: "swiper-button-next"
      }, null, -1))])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('home.hot_service1')), 1), _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "hot-logo"
      }, "HOT", -1))]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(HotService), item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.title,
          class: "left-item personal",
          onClick: $event => toOrder(item.linkParams, item)
        }, [_createElementVNode("p", _hoisted_32, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_33, _toDisplayString(item.desc), 1), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("span", null, "¥" + _toDisplayString(item.price), 1), _createTextVNode(" " + _toDisplayString(item.unit), 1)]), _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('home.text21')), 1)])], 8, _hoisted_31);
      }), 128))])])]), _createElementVNode("div", _hoisted_37, [_createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.$t('home.text39')), 1), _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$t('home.text40')), 1), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_cache[5] || (_cache[5] = _createElementVNode("img", {
        src: _imports_2,
        alt: ""
      }, null, -1)), _createElementVNode("div", null, [_createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.$t('home.hot_service8')), 1), _createElementVNode("div", _hoisted_44, [_createElementVNode("p", null, _toDisplayString(_ctx.$t('home.text42')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('home.text43')), 1)])])]), _createElementVNode("div", _hoisted_45, [_cache[6] || (_cache[6] = _createElementVNode("img", {
        src: _imports_3,
        alt: ""
      }, null, -1)), _createElementVNode("div", null, [_createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.$t('home.text44')), 1), _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('home.text45')), 1)])]), _createElementVNode("div", _hoisted_48, [_cache[7] || (_cache[7] = _createElementVNode("img", {
        src: _imports_4,
        alt: ""
      }, null, -1)), _createElementVNode("div", null, [_createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t('home.text46')), 1), _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t('home.text47')), 1)])]), _createElementVNode("div", _hoisted_51, [_cache[8] || (_cache[8] = _createElementVNode("img", {
        src: _imports_5,
        alt: ""
      }, null, -1)), _createElementVNode("div", null, [_createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.$t('home.text48')), 1), _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t('home.text49')), 1)])]), _createElementVNode("div", _hoisted_54, [_cache[9] || (_cache[9] = _createElementVNode("img", {
        src: _imports_6,
        alt: ""
      }, null, -1)), _createElementVNode("div", null, [_createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.$t('home.text50')), 1), _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$t('home.text51')), 1)])])]), _cache[10] || (_cache[10] = _createElementVNode("img", {
        src: _imports_7,
        class: "vs-icon",
        alt: ""
      }, null, -1)), _createElementVNode("div", _hoisted_57, [_createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.$t('home.text52')), 1), _createElementVNode("div", _hoisted_59, [_createElementVNode("p", null, _toDisplayString(_ctx.$t('home.text53')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('home.text54')), 1)]), _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t('home.text55')), 1), _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.$t('home.text56')), 1), _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$t('home.text57')), 1), _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t('home.text58')), 1)])])]), _createVNode(_component_AdvisoryService, {
        ref_key: "advisoryServiceRef",
        ref: advisoryServiceRef
      }, null, 512)]);
    };
  }
});